import React, { memo } from "react";
import { Box, Text } from "@chakra-ui/react";
import moment from "moment";
import {
  MESSAGE_THREAD_DATE_SEPERATOR_FORMAT,
  MONTH_DAY_YEAR_FORMAT,
} from "modules/utils/Constants";
import colors from "app/colors";

interface IProps {
  date?: string;
  displayContainer?: boolean;
}

const MessageDateSeparator = ({ date, displayContainer = false }: IProps) => {
  if (!date) {
    return null;
  }

  return (
    <Box w="full" justifyItems="center" pt="2px">
      <Box
        w="160px"
        textAlign="center"
        rounded="full"
        bg={colors.white}
        boxShadow={
          displayContainer ? "0px 0px 2px 2px rgba(0, 0, 0, 0.05)" : "none"
        }
      >
        <Text color={colors.gray30} fontSize={12} textTransform="uppercase">
          {moment(date).isSame(moment(), "year")
            ? moment(date).calendar(MESSAGE_THREAD_DATE_SEPERATOR_FORMAT)
            : moment(date).format(MONTH_DAY_YEAR_FORMAT)}
        </Text>
      </Box>
    </Box>
  );
};

export default memo(MessageDateSeparator);
